import { NavLink } from "react-router-dom";
import { NAV_ITEMS } from "./navItems";

export const AdminNavLinks = ({ onNavigate }) => (
  <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-0.5" data-testid="admin-nav-links">
    {NAV_ITEMS.map((item) => {
      const Icon = item.icon;
      return (
        <NavLink
          key={item.key}
          to={item.to}
          end={item.to === "/admin"}
          onClick={onNavigate}
          data-testid={`admin-nav-${item.key}`}
          className={({ isActive }) =>
            `flex items-center gap-3 px-3 py-2.5 rounded-lg text-xs font-bold tracking-wide uppercase transition-colors ${
              isActive ? "bg-stranger-orange text-clean-white" : "text-clean-white/60 hover:bg-white/10 hover:text-clean-white"
            }`
          }
        >
          <Icon className="w-4 h-4 shrink-0" />
          <span className="truncate">{item.label}</span>
        </NavLink>
      );
    })}
  </nav>
);
